module.exports = __webpack_public_path__ + "img/advantage11.af70fed9.jpg";